const getKm = (distance: number) => distance + ' km';

export default getKm;
